// @flow
export const copyToClipboard = (name: string) => {
  const $body = document.getElementsByTagName('body')[0];
  const $tempInput = document.createElement('INPUT');
  $tempInput.setAttribute('id', `tempInput-${(new Date()).getTime()}`);
  $body.appendChild($tempInput);
  if ($tempInput instanceof HTMLInputElement) {
    $tempInput.setAttribute('value', name);
    $tempInput.select();
    document.execCommand('copy');
    $body.removeChild($tempInput);
  }else {
    console.warn('$tempInput is not a valid DOM input');
  }
};



// WEBPACK FOOTER //
// ./src/utils/clipboard/index.js